var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_425_87283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.18312 2.5C2.40736 2.5 1.77436 3.07947 1.68572 3.82422L9.24373 8.5L16.8017 3.82422C16.7131 3.07947 16.0801 2.5 15.3043 2.5H3.18312ZM1.66797 5.31396V13C1.66797 13.8287 2.346 14.5 3.18312 14.5H12.2918C12.5221 14.374 12.7646 14.2663 13.0139 14.1748C12.5616 13.6536 12.274 12.9902 12.274 12.25C12.274 10.5955 13.6331 9.25 15.3043 9.25C15.8589 9.25 16.3718 9.40948 16.8195 9.66748V5.31396L9.24373 10L1.66797 5.31396ZM15.3043 10.75C14.9025 10.75 14.5171 10.908 14.233 11.1893C13.9488 11.4706 13.7892 11.8522 13.7892 12.25C13.7892 12.6478 13.9488 13.0294 14.233 13.3107C14.5171 13.592 14.9025 13.75 15.3043 13.75C15.7062 13.75 16.0916 13.592 16.3757 13.3107C16.6599 13.0294 16.8195 12.6478 16.8195 12.25C16.8195 11.8522 16.6599 11.4706 16.3757 11.1893C16.0916 10.908 15.7062 10.75 15.3043 10.75ZM15.3043 15.25C14.293 15.25 12.274 15.7525 12.274 16.75V17.5H18.3346V16.75C18.3346 15.7525 16.3157 15.25 15.3043 15.25Z",
    fill: "#0044C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_425_87283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteFigma);
export default __webpack_public_path__ + "static/media/invite-figma.cdaaf220edc82b475b6a490542cd8056.svg";
export { ForwardRef as ReactComponent };